import axios from 'axios'
import {baseHost} from "./common";
import { getToken } from '@/utils/auth'

const service = axios.create({
    // 公共接口--这里注意后面会讲
    baseURL: baseHost,
    // 超时时间 单位是ms，这里设置了5s的超时时间
    timeout: 5 * 1000
})

service.interceptors.request.use(config => {
    if (getToken()) {
        config.headers['token'] = getToken()
    }
    return config
}, error => {
    Promise.reject(error)
})

service.interceptors.response.use(response => {
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    return response.data
}, error => {
    console.log(error.message)
    /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response)
})

export default service
